export const howWorkData = [
    {
        image: 'ecommerce-landing-step1',
        title: 'Step',
        key: 'step1',
        description: 'Find brands that have similar customers like yours.'
    },
    {
        image: 'ecommerce-landing-step2',
        title: 'Step',
        key: 'step2',
        description: 'Choose the cross promotional channel (newsletter, social media, blog post etc.)'
    },
    {
        image: 'ecommerce-landing-step3',
        title: 'Step',
        key: 'step3',
        description: 'Cross promote with each other, get relevant traffic and sales. '
    },
]